import { fetcherReactQuery, MutationReactQuery } from '../../services/api/fetcher';
import { useQuery } from 'react-query';

const fetchTermsAcceptance = async (_, empleadoId) => {
    const tipoComunicado = 1; // Id2 fijo = 1
    const api = `/api/empleadoaviso/${empleadoId}/${tipoComunicado}`;
    try {
        const response = await fetcherReactQuery(api);
        return response.data;
    } catch (err) {
        // Si retorna 404, significa que no ha aceptado
        if (err.response && err.response.status === 404) {
            return null;
        }
        throw err;
    }
};

const useTermsAcceptance = (empleadoId) => {
    // Verificar si la validación está activa usando la variable del usuario
    const isValidationActive = process.env.REACT_APP_VALIDATE_AVISOS_CONDICIONES === 'true';
    
    return useQuery(
        ["termsAcceptance", empleadoId],
        fetchTermsAcceptance,
        {
            enabled: isValidationActive && !!empleadoId,
            refetchOnWindowFocus: false,
            //staleTime: 300000, // 5 minutos
            retry: false // No reintentar si falla
        }
    );
};

const fetchMutationAcceptTerms = async (data) => {
    const response = await MutationReactQuery(
        "post",
        "/api/empleadoaviso/create",
        data
    );
    return response.data;
};

export {
    useTermsAcceptance,
    fetchMutationAcceptTerms
};

